import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, {
    type: $setup.incoming.type ?? 'error',
    class: "my-2 text-start",
    variant: "tonal",
    closable: $setup.closable
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString($setup.incoming.message), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["type", "closable"]))
}